// Rooms
export default function rooms() {
	const roomJsonPath = "/wp-content/themes/leafescote/assets/rooms/rooms.json";
	fetch(roomJsonPath)
	.then(response => response.json())
	.then(data => {
		setLayouts(data);
	});
};

const setLayouts = (json)=> {
	const buttons = document.getElementById("buttons");
	const rooms = document.getElementById("rooms");
	if (buttons!==null && rooms!==null) {
		const place = buttons.dataset.place;
		const roomsInfo = json[place];
		roomsInfo.forEach(element => {
			// make buttons
			const label = element.type;
			const subLabel = element.sub === null ? "" : `<span>${element.sub}</span>`;
			const id = element.id === undefined ? element.type : element.id;
			const button
			= `<button data-id="${id}">${subLabel}${label}<span>タイプ</span></button>`;
			buttons.insertAdjacentHTML('beforeend', button);

			// make cards
			const path = rooms.dataset.path;
			const file = element.file;
			const area = element.area;
			const note = element.note === null ? "" : `<span class="_note">${element.note}</span>`;
			const cardLabel = element.sub === null ? "" : `<small>${element.sub}</small>`;
			const card = `
			<figure data-id="${id}" class="property_rooms_info property_card">
				<img src="${path}${file}" alt="${label}">
				<figcaption>
					<dl>
						<dt>${cardLabel}${label}<span>タイプ</span></dt>
						<dd>専有面積<span>${area} ㎡</span></dd>
					</dl>
					${note}
				</figcaption>
			</figure>
			`;
			rooms.insertAdjacentHTML('beforeend', card);
		});

		//Firest view
		buttons.querySelector("button").classList.add("active");
		rooms.querySelector("figure").classList.add("active");

		//button setting
		const allButton = buttons.querySelectorAll("button");
		allButton.forEach(element => {
			element.addEventListener("click", (event)=> {
				if (event.target.tagName === 'SPAN') {
					// スパンがクリックされた場合にも、親要素であるボタンをクリックしたことにする
					event.stopPropagation(); // 子要素のイベント伝播を停止する
					element.click(); // ボタンをクリックしたことにする
				} else {
				// ボタンがクリックされた場合の処理
					const me = event.target;
					const id = me.dataset.id;

					rooms.querySelectorAll(".property_card").forEach(element => {
						element.classList.remove("active");
					});
					buttons.querySelectorAll("button").forEach(element => {
						element.classList.remove("active");
					});
					const target = rooms.querySelector(`[data-id='${id}']`);
					target.classList.add("active");
					me.classList.add("active");
				}
			})
		})
	}
}